export const TOUR_STEP_IDS = {
  TEAM_SWITCHER: "team-switcher",
  WRITING_AREA: "writing-area",
  ASK_AI: "ask-ai",
  FAVORITES: "favorites",
};
